import { useZoomContext } from '@state/checkout-contexts';
import { ChkThemeProvider } from '@ui/checkout-components';

import { useJwtContext } from '../../hooks/useJwtContext/useJwtContext';

import type { ThemeProviderProps } from './ThemeProvider.types';

export const ThemeProvider = ({ variant, children }: ThemeProviderProps) => {
  const zoom = useZoomContext();
  const { payload } = useJwtContext();

  return (
    <ChkThemeProvider
      variant={variant}
      zoom={zoom}
      customerBranding={payload?.branding}
    >
      {children}
    </ChkThemeProvider>
  );
};
